import React from "react";
import Webcam from "react-webcam";
import "./index.scss";

interface CamRecorderProps {
  handleCameraAccessdenied: () => void;
}

const CamRecorder: React.FC<CamRecorderProps> = ({
  handleCameraAccessdenied,
}) => {
  const handleUserMediaError = (error: string | DOMException) => {
    console.error("Camera error:", error);
    handleCameraAccessdenied();
  };

  return (
    <div className="cam-recorder-container">
      <Webcam
        audio={false}
        videoConstraints={{ facingMode: "user" }}
        onUserMediaError={handleUserMediaError}
      />
    </div>
  );
};

export default CamRecorder;
